import type { IconName } from "../design-system/Icon";

export interface NavItem {
  readonly id: string;
  readonly label: string;
  readonly path: string;
  readonly icon: IconName;
  readonly group: "executive" | "commerce" | "operations" | "intelligence" | "system";
}

/** Registro de navegación: Dashboard Ejecutivo (The Brain) + los 13 motores. */
export const NAV_ITEMS: readonly NavItem[] = [
  { id: "dashboard", label: "Dashboard Ejecutivo", path: "/", icon: "brain", group: "executive" },
  { id: "product", label: "Producto", path: "/producto", icon: "product", group: "commerce" },
  { id: "marketplace", label: "Marketplace", path: "/marketplace", icon: "marketplace", group: "commerce" },
  { id: "sales", label: "Ventas", path: "/ventas", icon: "sales", group: "commerce" },
  { id: "pricing", label: "Precios", path: "/precios", icon: "pricing", group: "commerce" },
  { id: "inventory", label: "Inventario", path: "/inventario", icon: "inventory", group: "operations" },
  { id: "purchase", label: "Compras", path: "/compras", icon: "purchase", group: "operations" },
  { id: "supplier", label: "Proveedores", path: "/proveedores", icon: "supplier", group: "operations" },
  { id: "logistics", label: "Logística", path: "/logistica", icon: "logistics", group: "operations" },
  { id: "customer", label: "Clientes", path: "/clientes", icon: "customer", group: "commerce" },
  { id: "finance", label: "Finanzas", path: "/finanzas", icon: "finance", group: "operations" },
  { id: "product-development", label: "Desarrollo de Producto", path: "/desarrollo-producto", icon: "flask", group: "intelligence" },
  { id: "market-trends", label: "Tendencias ML", path: "/tendencias", icon: "spark", group: "intelligence" },
  { id: "analytics", label: "Analytics", path: "/analytics", icon: "analytics", group: "intelligence" },
  { id: "ai", label: "IA", path: "/ia", icon: "ai", group: "intelligence" },
  { id: "security", label: "Seguridad", path: "/seguridad", icon: "shield", group: "system" },
];

export const NAV_GROUPS: Record<NavItem["group"], string> = {
  executive: "Dirección",
  commerce: "Comercial",
  operations: "Operaciones",
  intelligence: "Inteligencia",
  system: "Sistema",
};
